import { useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import BottomSheetDialogTemplate from 'components/molecules/BottomSheetDialog/BottomSheetDialogTemplate';

import { comicsSelector } from '@lootboy/lib/selectors';

import { TUseBooleanState } from '~/hooks/useBooleanState';

import firstComicImage from './images/first-comic.png';
import newComicImage from './images/new-comic.png';

import styles from './ComicsInfoDialog.module.scss';

interface IComicsInfoDialog {
  booleanState: TUseBooleanState;
}

// todo: this should be moved to lib
const comicsDialogSelector = createSelector(
  comicsSelector,
  ({ sortOrder, items, readComics, lastSuccessfulFetch }) => ({
    firstComic: sortOrder > 0 ? items[0] : items[items.length - 1],
    hasReadComics: Object.keys(readComics || {}).length > 0,
    lastSuccessfulFetch,
  }),
);

export default function ComicsInfoDialog({
  booleanState,
}: IComicsInfoDialog): JSX.Element | null {
  const [isOpen, { setFalse: setBooleanStateFalse }] = booleanState;
  const { firstComic, hasReadComics, lastSuccessfulFetch } =
    useSelector(comicsDialogSelector);

  if (!lastSuccessfulFetch || !isOpen) {
    return null;
  }

  const sharedProps = {
    onClose: setBooleanStateFalse,
    header: 'TabBar_tab_comics',
    contentClassName: styles.ComicsInfoDialog,
  };

  if (hasReadComics) {
    return (
      <BottomSheetDialogTemplate
        {...sharedProps}
        src={newComicImage}
        headlineTranslation="ComicDetailView_bs_new_comic_headline"
        descriptionTranslation="ComicDetailView_bs_new_comic"
        buttonTranslation="ComicDetailView_bs_new_comic_pbutton"
      />
    );
  }

  return (
    <BottomSheetDialogTemplate
      {...sharedProps}
      src={firstComicImage}
      headlineTranslation="ComicDetailView_bs_first_comic_headline"
      descriptionTranslation="ComicDetailView_bs_first_comic"
      buttonTranslation="ComicDetailView_bs_first_comic_pbutton"
      to={`/comics/${firstComic._id}`}
    />
  );
}
